import React from "react";
import { Modal } from "flowbite-react";

const StaticPopupNew = ({
  openModal,
  handleClose,
  header,
  headerSub,
  children,
  // height = 60,
  width = "xl",
  size = "lg",
  headerLogo,
  bodyStyle = `pb-8 pt-3`,
  bodyOverflow = "overflow-auto",
  dismissible = true,
  showCloseButton = true
}) => {

  return (
    <div>
      <Modal
        style={{ zIndex: "50" }}
        dismissible={dismissible}
        show={openModal}
        onClose={handleClose}
        size={width}
      >
        <div
          className={`flex justify-between w-full ${size === "sm" ? "pl-4" : "pl-4"
            } pr-4 py-2 border-b-[1px] border-gray-200`}
        >
          <div className="flex gap-3 items-center w-full">
            {headerLogo && (
              <div className="max-h-6">
                {/* <div dangerouslySetInnerHTML={{ __html: headerLogo }} /> */}
                {headerLogo}
              </div>
            )}
            <p className=" text-lg font-semibold w-full">
              {header}
              {headerSub && (
                <span className="text-xs font-extralight ml-1 italic">
                  {`( ${headerSub} )`}
                </span>
              )}
            </p>
          </div>
          {showCloseButton && (
  <button
    className="self-start hover:bg-slate-100 px-1 text-xs text-[#3F4B64] flex gap-2 items-center"
    onClick={handleClose}
  >
    Close
    <svg
      width="10"
      height="10"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1 1L11 11M11 1L1 11"
        stroke="#232E9B"
        strokeLinecap="round"
      />
    </svg>
  </button>
)}

        </div>
        <div
          className={` ${bodyStyle}${size === "sm" ? " " : ""
            } flex flex-col gap-6 overflow-auto ${bodyOverflow}`}
        >
          {children}
        </div>
      </Modal>
    </div>
  );
};

export default StaticPopupNew;
